<mat-form-field appearance="outline" class="dosage-type-search-field">
  <mat-label>{{ label }}</mat-label>
  <input
    required
    type="text"
    matInput
    placeholder="Search dosage types"
    [formControl]="formControl"
    [matAutocomplete]="dosageTypeAuto"
    (input)="onSearchInput($event)"
  />
  <mat-autocomplete
    #dosageTypeAuto="matAutocomplete"
    [displayWith]="displayDosageType"
    autoActiveFirstOption
    panelClass="medicine-lookup-autocomplete-panel"
  >
    @for (type of dosageTypes; track type.id) {
      <mat-option [value]="type">{{ type.type }}</mat-option>
    }
  </mat-autocomplete>
  <mat-icon matPrefix>search</mat-icon>
  <button type="button" matSuffix mat-icon-button (click)="createDosageType($event)">
    <mat-icon>add</mat-icon>
  </button>
  @if (control.invalid && (control.dirty || control.touched)) {
    <mat-error>Dosage type is invalid</mat-error>
  }
  @if (isSearching) {
    <mat-hint>Searching...</mat-hint>
  }
</mat-form-field>
